/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, FileData, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from '../request'

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult,
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (requestData: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult) & {
  requestConfig: TRequestConfig
}

const mockUrl_0_0_0_57 = 'http://127.0.0.1:50505/mock/0' as any
const devUrl_0_0_0_57 = '' as any
const prodUrl_0_0_0_57 = '' as any
const dataKey_0_0_0_57 = 'data' as any

/**
 * 接口 编辑到货单的装箱信息 的 **请求类型**
 *
 * @分类 到货明细
 * @请求头 `POST /arrivalItemPackingInfo/edit`
 */
export interface EditRequest {
  /**
   * 到货单主键ID
   */
  arrival_item_id?: number
  /**
   * 装箱明细
   */
  detail_list?: {
    /**
     * 最长边
     */
    longest_side?: string
    /**
     * 发货数量
     */
    num?: number
    /**
     * 分装箱子数量
     */
    num_of_boxes?: number
    /**
     * 单箱产品个数
     */
    num_of_single_box?: number
    /**
     * 次长边
     */
    second_long_side?: string
    /**
     * 最短边
     */
    shortest_side?: string
    /**
     * 装箱总数量
     */
    total_num?: number
  }[]
  /**
   * 流转单号
   */
  package_code?: string
  /**
   * 订单编号
   */
  purchase_order_code?: string
}

/**
 * 接口 编辑到货单的装箱信息 的 **返回类型**
 *
 * @分类 到货明细
 * @请求头 `POST /arrivalItemPackingInfo/edit`
 */
export interface EditResponse {
  /**
   * 状态码
   */
  code?: number
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 编辑到货单的装箱信息 的 **请求配置的类型**
 *
 * @分类 到货明细
 * @请求头 `POST /arrivalItemPackingInfo/edit`
 */
type EditRequestConfig = Readonly<
  RequestConfig<'http://127.0.0.1:50505/mock/0', '', '', '/arrivalItemPackingInfo/edit', 'data', string, string, false>
>

/**
 * 接口 编辑到货单的装箱信息 的 **请求配置**
 *
 * @分类 到货明细
 * @请求头 `POST /arrivalItemPackingInfo/edit`
 */
const editRequestConfig: EditRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_57,
  devUrl: devUrl_0_0_0_57,
  prodUrl: prodUrl_0_0_0_57,
  path: '/arrivalItemPackingInfo/edit',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_57,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'edit',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 编辑到货单的装箱信息 的 **请求函数**
 *
 * @分类 到货明细
 * @请求头 `POST /arrivalItemPackingInfo/edit`
 */
export const edit = /*#__PURE__*/ (requestData: EditRequest, ...args: UserRequestRestArgs) => {
  return request<EditResponse>(prepare(editRequestConfig, requestData), ...args)
}

edit.requestConfig = editRequestConfig

/**
 * 接口 根据发货明细id获取装箱详细 的 **请求类型**
 *
 * @分类 到货明细
 * @请求头 `POST /arrivalItemPackingInfo/queryByArrivalItemIds`
 */
export interface QueryByArrivalItemIdsRequest {
  arrival_item_ids?: number[]
}

/**
 * 接口 根据发货明细id获取装箱详细 的 **返回类型**
 *
 * @分类 到货明细
 * @请求头 `POST /arrivalItemPackingInfo/queryByArrivalItemIds`
 */
export interface QueryByArrivalItemIdsResponse {
  /**
   * 状态码
   */
  code?: number
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  /**
   * 正确结果
   */
  result?: {
    /**
     * 到货明细主键ID
     */
    arrival_item_id?: number
    /**
     * 装箱信息详细
     */
    detaillist?: {
      /**
       * 装箱数据主键id
       */
      id?: number
      /**
       * 最长边
       */
      longest_side?: string
      /**
       * 发货数量
       */
      num?: number
      /**
       * 分装箱子数量
       */
      num_of_boxes?: number
      /**
       * 单箱产品个数
       */
      num_of_single_box?: number
      /**
       * 整箱毛重
       */
      outer_box_gross_weight?: number
      /**
       * 整箱净重
       */
      outer_box_net_weight?: number
      /**
       * 次长边
       */
      second_long_side?: string
      /**
       * 最短边
       */
      shortest_side?: string
      /**
       * 装箱总数量
       */
      total_num?: number
    }[]
    /**
     * 流转单号
     */
    package_code?: string
    /**
     * 产品编码
     */
    product_code?: string
    /**
     * 产品id
     */
    product_id?: number
    /**
     * 属性编码
     */
    property_code?: string
    /**
     * 属性id
     */
    property_id?: number
    /**
     * 订单编号
     */
    purchase_order_code?: string
  }[]
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 根据发货明细id获取装箱详细 的 **请求配置的类型**
 *
 * @分类 到货明细
 * @请求头 `POST /arrivalItemPackingInfo/queryByArrivalItemIds`
 */
type QueryByArrivalItemIdsRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/arrivalItemPackingInfo/queryByArrivalItemIds',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 根据发货明细id获取装箱详细 的 **请求配置**
 *
 * @分类 到货明细
 * @请求头 `POST /arrivalItemPackingInfo/queryByArrivalItemIds`
 */
const queryByArrivalItemIdsRequestConfig: QueryByArrivalItemIdsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_57,
  devUrl: devUrl_0_0_0_57,
  prodUrl: prodUrl_0_0_0_57,
  path: '/arrivalItemPackingInfo/queryByArrivalItemIds',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_57,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'queryByArrivalItemIds',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 根据发货明细id获取装箱详细 的 **请求函数**
 *
 * @分类 到货明细
 * @请求头 `POST /arrivalItemPackingInfo/queryByArrivalItemIds`
 */
export const queryByArrivalItemIds = /*#__PURE__*/ (
  requestData: QueryByArrivalItemIdsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<QueryByArrivalItemIdsResponse>(prepare(queryByArrivalItemIdsRequestConfig, requestData), ...args)
}

queryByArrivalItemIds.requestConfig = queryByArrivalItemIdsRequestConfig

/**
 * 接口 保存到货单的装箱信息 的 **请求类型**
 *
 * @分类 到货明细
 * @请求头 `POST /arrivalItemPackingInfo/saveBatch`
 */
export type SaveBatchRequest = {
  /**
   * 到货单Id
   */
  arrival_item_id: number
  /**
   * 发货单编号
   */
  delivery_code: string
  /**
   * 发货单Id
   */
  delivery_id: number
  /**
   * 发货单明细Id
   */
  delivery_item_id: number
  /**
   * 最长边
   */
  longest_side: string
  /**
   * 发货数量
   */
  num: number
  /**
   * 分装箱子数量
   */
  num_of_boxes: number
  /**
   * 单箱产品个数
   */
  num_of_single_box: number
  /**
   * 整箱毛重
   */
  outer_box_gross_weight: number
  /**
   * 整箱净重
   */
  outer_box_net_weight: number
  /**
   * 流转单编号
   */
  package_code: string
  /**
   * 产品编号
   */
  product_code: string
  /**
   * 产品id
   */
  product_id: number
  /**
   * 属性编号
   */
  property_code?: string
  /**
   * 属性Id
   */
  property_id?: number
  /**
   * 订单编号
   */
  purchase_order_code: string
  /**
   * 次长边
   */
  second_long_side: string
  /**
   * 最短边
   */
  shortest_side: string
}[]

/**
 * 接口 保存到货单的装箱信息 的 **返回类型**
 *
 * @分类 到货明细
 * @请求头 `POST /arrivalItemPackingInfo/saveBatch`
 */
export interface SaveBatchResponse {
  /**
   * 状态码
   */
  code?: number
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 保存到货单的装箱信息 的 **请求配置的类型**
 *
 * @分类 到货明细
 * @请求头 `POST /arrivalItemPackingInfo/saveBatch`
 */
type SaveBatchRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/arrivalItemPackingInfo/saveBatch',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 保存到货单的装箱信息 的 **请求配置**
 *
 * @分类 到货明细
 * @请求头 `POST /arrivalItemPackingInfo/saveBatch`
 */
const saveBatchRequestConfig: SaveBatchRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_57,
  devUrl: devUrl_0_0_0_57,
  prodUrl: prodUrl_0_0_0_57,
  path: '/arrivalItemPackingInfo/saveBatch',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_57,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'saveBatch',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 保存到货单的装箱信息 的 **请求函数**
 *
 * @分类 到货明细
 * @请求头 `POST /arrivalItemPackingInfo/saveBatch`
 */
export const saveBatch = /*#__PURE__*/ (requestData: SaveBatchRequest, ...args: UserRequestRestArgs) => {
  return request<SaveBatchResponse>(prepare(saveBatchRequestConfig, requestData), ...args)
}

saveBatch.requestConfig = saveBatchRequestConfig

/* prettier-ignore-end */
